<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex justify-content-between align-items-center"
            >
              <h4 class="card-title">{{ $route.params.id }}</h4>
              <pdf
                :user_id="0"
                :document="search"
                :goods="[]"
                :doc_id="0"
                source="aml"
                :doc_additional="filters"
              ></pdf>
            </div>
            <div class="card-body">
              <article>
                <b-tabs
                  pills
                  content-class="mt-3"
                  small
                  v-if="search.content.data.hits.length > 0"
                >
                  <b-tab
                    :title="$t('message.aml.aka')"
                    lazy
                    v-if="hit.doc.aka.length > 0"
                  >
                    <div v-for="name in hit.doc.aka">{{ name.name }}</div>
                  </b-tab>
                  <b-tab
                    :title="$t('message.aml.fields')"
                    lazy
                    v-if="hit.doc.fields.length > 0"
                  >
                    <div class="row">
                      <div class="col-3 font-weight-bold subline">
                        {{ $t("message.aml.countries") }}
                      </div>
                      <div class="col-9 text">
                        {{ getCountries(hit.doc.fields) }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 font-weight-bold subline">
                        {{ $t("message.aml.DOB") }}
                      </div>
                      <div class="col-9 text">
                        {{ getDateOfBirth(hit.doc.fields) }}
                      </div>
                    </div>
                    <div v-for="associate in current_hit.doc.associates">
                      <div class="row">
                        <div class="col-3 font-weight-bold subline">
                          {{ $t("message.aml.associates") }}
                        </div>
                        <div class="col-9 text">
                          {{ associate.association + " " + associate.name }}
                        </div>
                      </div>
                    </div>
                    <div v-for="othr in getOtherFields(hit.doc.fields)">
                      <div class="row">
                        <div class="col-3 font-weight-bold subline">
                          {{ $t("message.aml.other_info") }}
                        </div>
                        <div class="col-9 text">{{ othr.value }}</div>
                      </div>
                    </div>
                    <br />

                    <div v-for="note in hit.doc.source_notes">
                      <div v-if="note.aml_types[0] == 'adverse-media'">
                        <div class="row">
                          <div class="col-2">
                            <p hidden></p>
                            <a
                              :href="note.url"
                              class="badge badge-pill badge-warning"
                              >{{ getResponseType(note.aml_types[0]) }}</a
                            >
                          </div>
                          <div class="col-10 subtitle">{{ note.name }}</div>
                        </div>
                        <div class="row">
                          <div class="col-2"></div>
                          <div class="col-3 subline">
                            {{ $t("message.aml.countries") }}
                          </div>
                          <div class="col-7">
                            {{ note.country_codes.join() }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-2"></div>
                          <div class="col-3 subline">
                            {{ $t("message.aml.adverse_media_subtype") }}
                          </div>
                          <div class="col-7">
                            {{ getResponseTypes(note.aml_types.slice(1)) }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-2"></div>
                          <div class="col-3 subline">
                            {{ $t("message.aml.related_url") }}
                          </div>
                          <div class="col-7">
                            <a
                              :href="note.url"
                              rel="noopener noreferrer"
                              target="_blank"
                              >{{ note.url }}</a
                            >
                          </div>
                        </div>
                        <br />
                      </div>

                      <div v-else>
                        <div class="row">
                          <div class="col-2">
                            <p hidden></p>
                            <a
                              :href="note.url"
                              class="badge badge-pill badge-warning"
                              >{{ getResponseType(note.aml_types[0]) }}</a
                            >
                          </div>
                          <div class="col-10 subtitle">{{ note.name }}</div>
                        </div>

                        <div class="row">
                          <div class="col-2"></div>
                          <div class="col-3 subline">
                            {{ $t("message.aml.created_at") }}
                          </div>
                          <div class="col-7">
                            {{ note.listing_started_utc }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-2"></div>
                          <div class="col-3 subline">
                            {{ $t("message.aml.related_url") }}
                          </div>
                          <div class="col-7">
                            <a
                              :href="note.url"
                              rel="noopener noreferrer"
                              target="_blank"
                              >{{ note.url }}</a
                            >
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                    <!-- <div class="row">
											<div class="col-4 font-weight-bold">{{$t('message.aml.field_name')}}</div>
											<div class="col-4 font-weight-bold">{{$t('message.aml.field_source')}}</div>
											<div class="col-4 font-weight-bold">{{$t('message.aml.field_value')}}</div>
										</div>
										<div v-for="field in hit.doc.fields">
											<div class="row mb-2">
												<div class="col-4">{{field.name}}</div>
												<div class="col-4">{{hitSourceName(field.source)}}</div>
												<div class="col-4"><span v-if="!isValidUrl(field.value)">{{field.value}}</span><a :href="field.value" target=_blank v-else>{{field.value}}</a></div>
											</div>
										</div> -->
                  </b-tab>
                  <b-tab
                    :title="$t('message.aml.media')"
                    lazy
                    v-if="
                      typeof hit.doc.media !== 'undefined' &&
                      hit.doc.media.length > 0
                    "
                  >
                    <div v-for="media in hit.doc.media">
                      <div
                        class="row py-2 px-0 border border-top-0 border-left-0 border-right-0"
                      >
                        <div class="col-12 font-weight-bold">
                          <a
                            :href="media.url"
                            rel="noopener noreferrer"
                            target="_blank"
                            >{{ media.title }}</a
                          >
                          <small>({{ momentum(media.date) }})</small>
                        </div>
                        <div class="col-12">{{ media.snippet }}</div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
                <div v-else>
                  {{ $t("message.aml.noresults") }}
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      search: false,
      article: {},
      filters: {},
    };
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    var url = window.base + "/document/aml/?query=";
    if (window.location.hostname == "attistrade.cn")
      url =
        "https://attistrade.kz/api/search_query/?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809&query=";
    if (window.location.hostname == "attistrade.ru")
      url =
        "https://attistrade.kz/api/search_query/?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809&query=";
    axios.get(url + this.$route.params.id).then((response) => {
      this.search = response.data;
      this.filters = response.data.content.data.filters;
      this.filters.search_term = this.$route.params.id;
    });
  },
  computed: {
    hit() {
      if (
        this.search !== false &&
        typeof this.search.content.data.hits[0] !== "undefined"
      )
        return this.search.content.data.hits[0];
      return {};
    },
  },
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    hitSourceName(str) {
      if (typeof this.hit.doc.source_notes[str] !== "undefined")
        return this.hit.doc.source_notes[str].name;
      return "";
    },
    isValidUrl(str) {
      var a = document.createElement("a");
      a.href = str;
      return a.host && a.host != window.location.host;
    },
    getCountries(fields) {
      fields = fields.filter((field) => field.name.trim() === "Countries");
      fields = fields.map((field) => {
        return field.value;
      });
      return fields[0];
    },
    getDateOfBirth(fields) {
      var dobs = fields.filter(
        (field) => field.name.trim() === "Date of Birth",
      );
      if (typeof dobs[0] != "undefined") return dobs[0].value;
      else return "";
    },
    getResponseTypes(types) {
      return types
        .map((type) => {
          return this.$t(
            "message.comply_advantage.response_match_" + type.trim(),
          );
        })
        .join(",");
    },
    getResponseType(type) {
      return this.$t("message.comply_advantage.response_match_" + type.trim());
    },
    getOtherFields(fields) {
      // var res = fields.map(field => {
      //     return field.value
      // }).join(",");
      // res = res.filter((v, i, a) => a.indexOf(v) === i);
      if (typeof (fields !== "undefined") && _.isArray(fields)) {
        fields = fields.filter((field) => field.name.trim() === "Other Info");
        // fields = fields.map(field => {
        //     return field.value;
        // });
        return fields;
      }

      return "";
    },
  },
};
</script>
